import { FunctionalityClient } from '@frontend/functionality/api';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { ValidLicensesCardProps } from './valid-licenses-card.component';

interface ViewProps {
    apps: string[];
    isLoading: boolean;
}

export const useValidLicensesCard = (props: ValidLicensesCardProps): ViewProps => {
    const { currentAccount } = useAccountRepository();
    const [apps, setApps] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!currentAccount) {
            setIsLoading(false);
            return;
        }

        FunctionalityClient.fetchFunctionalities({ account_id: currentAccount })
            .then((response) => {
                setApps(Array.from(new Set(response.results.map((func) => func.application + ' ' + func.type))));
                setIsLoading(false);
            })
            .catch(() => {
                setApps([]);
                setIsLoading(false);
            });
    }, [currentAccount]);

    return {
        apps,
        isLoading
    };
};
